<template>
  <v-dialog v-model="dialog" :persistent="saving" max-width="530" scrollable>
    <v-card>
      <v-card-title>設定自訂約診標籤</v-card-title>
      <v-card-text style="max-height: 500px;">
        <v-alert v-if="error" type="error" text dense role="alert">{{ error }}</v-alert>
        <v-row v-for="(tag, idx) in editFilterReserveTagsItems" :key="idx" dense class="align-center">
          <v-col cols="auto" md="2" class="flex-shrink-1">
            <v-chip small>#標籤{{ idx + 1 }}</v-chip>
          </v-col>
          <v-col md="10" class="flex-grow-1">
            <v-text-field
              v-model="tag.content"
              :disabled="saving"
              placeholder="請輸入標籤名稱"
              outlined
              dense
              single-line
              hide-details
              class="tag-input"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn small :loading="saving" :disabled="saving" width="100" color="primary" @click="confirmReserveTagName">確定修改</v-btn>
        <v-btn small :disabled="saving" width="100" color="grey-4" @click="dialog = false">取消</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { updateCustomReserveTagsAPI } from '@/api/reserve';
import { customReserveTags } from '@/utils/smartCareReserve';
import { mapGetters } from 'vuex';

export default {
  name: "ReserveTagEditor",
  props: {
    editReserveTagNameDialog: {
      type: Boolean,
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      editFilterReserveTagsItems: [],
      saving: false,
      error: '',
    }
  },
  computed: {
    ...mapGetters([
      'axiosParamData',
    ]),
    dialog: {
      get() {
        return this.editReserveTagNameDialog
      },
      set(value) {
        if (this.saving) return;
        this.$emit('update:editReserveTagNameDialog', value)
      },
    },
  },
  methods: {
    async confirmReserveTagName() {
      if (this.saving) return;
      const setting_data = customReserveTags(this.editFilterReserveTagsItems)
        .filter(e => e.content && e.content.trim())
        .map(({ tag_id, content }) => ({ tag_id, content: content.trim() }))
      if (setting_data.length > 20) {
        this.error = '自訂約診標籤最多可設定 20 組。';
        return;
      }
      const data = {
        ...this.axiosParamData,
        setting_data
      }
      this.saving = true;
      this.error = '';
      try {
        await updateCustomReserveTagsAPI(data);
        this.$emit('getData')
        this.$emit('update:editReserveTagNameDialog', false);
      } catch (error) {
        this.error = '自訂約診標籤儲存失敗，請重新確認。';
      } finally {
        this.saving = false;
      }
    },
  },
  mounted() {
    this.editFilterReserveTagsItems = JSON.parse(JSON.stringify(customReserveTags(this.items)))
  }
}
</script>

<style scoped>

</style>
